module.exports = __webpack_public_path__ + "img/picture_empty.c707b3be.png";